/**
 * "지금 화면이 서버가 랜딩으로 그린 그 주소인가" — 랜딩 제목(H1)·하단 링크를 보여 줄지 정하는 키.
 *
 * 서버는 색인 랜딩(도시·카테고리·도시×품목·국가×품목)일 때 제목과 함께 이 키를 내려보내고,
 * 클라이언트는 지금 주소로 같은 키를 만들어 비교한다. 카테고리 칩·"이 지역에서 검색"·검색어처럼
 * 서버를 다시 거치지 않는 얕은 이동으로 주제가 바뀌면 키가 달라져 원래 문구로 돌아간다.
 *
 * 주제를 정하는 값만 담는다 — 지도 뷰(zoom·clat·clng·t)·범위(ne/sw)·정렬·날짜·가격·허브 시트는
 * 같은 주제 안의 상태라 넣지 않는다(지도를 끌거나 정렬을 바꿔도 제목은 그대로).
 * 서버 전용 모듈을 가져오지 않는다 — 페이지와 클라이언트가 함께 쓴다.
 */
type ParamSource = URLSearchParams | { get(key: string): string | null };

const TOPIC_KEYS = ["scope", "country", "region", "q", "search", "location_search", "place"] as const;

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

/**
 * @param region 경로의 region 세그먼트(인코딩 여부 무관)
 * @param categories 정규화한 카테고리 코드(normalizeCategoryCodes) — 순서는 무시한다
 */
export function landingMatchKey(
  region: string,
  params: ParamSource,
  categories: readonly string[],
): string {
  const topic = TOPIC_KEYS.map((key) => `${key}=${params.get(key) ?? ""}`).join("&");
  const codes = [...categories].sort().join(",");
  return `${safeDecode(region)}|${topic}&categories=${codes}`;
}
